import { render, staticRenderFns } from "./UserAdmins.vue?vue&type=template&id=9f711f76"
import script from "./UserAdmins.vue?vue&type=script&lang=js"
export * from "./UserAdmins.vue?vue&type=script&lang=js"
import style0 from "./UserAdmins.vue?vue&type=style&index=0&id=9f711f76&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports